import { Image, Stack, Text, Title } from "@mantine/core";
import { FormattedMessage, useIntl } from "react-intl";
import { AppWebviewLayout } from "../AppWebviewLayout";
import { AppWebviewButton } from "../AppWebviewButton";
import { ActionCarousel, type ActionCard } from "../overview/ActionCarousel";
import illustration from "../../../assets/fetching-offers.svg?url";

/**
 * No presentee company reported a pension and the state pension is empty too, so
 * the POA was ended and the customer is blocked from signing a new one for a while.
 * `onRetry` arrives once the block has passed.
 */
export function NoPensionFoundScreen({
  cards,
  onRetry,
}: {
  cards: ActionCard[];
  onRetry?: () => void;
}) {
  const intl = useIntl();

  return (
    <AppWebviewLayout
      footer={
        onRetry && (
          <AppWebviewButton
            size="lg"
            fz="md"
            onClick={onRetry}
            rightSection={false}
          >
            <FormattedMessage
              id="app.poaOnb.reActivation.CTA"
              defaultMessage="Ge ny fullmakt"
            />
          </AppWebviewButton>
        )
      }
    >
      <Stack gap="xl">
        <Stack gap="lg">
          <Image
            src={illustration}
            alt=""
            w="auto"
            fit="contain"
            mx="auto"
            maw={191}
          />
          <Stack gap="xs">
            <Title
              order={1}
              size="24"
              ff="var(--wallet-font-family-sambla-sans)"
              ta="center"
            >
              <FormattedMessage
                id="app.poaOverview.noPensionFound.headline"
                defaultMessage="Vi hittade ingen pensionsinformation"
              />
            </Title>
            <Text size="md" ta="center" c="var(--wallet-color-neutrals-black)">
              <FormattedMessage
                id="app.poaOverview.noPensionFound.description"
                defaultMessage="Det kan till exempel bero på att du nyligen har börjat arbeta i Sverige, eller att dina pensioner inte har registrerats än. Vi har därför avslutat fullmakten och hämtar inte längre in några uppgifter."
              />
            </Text>
          </Stack>
        </Stack>
        <ActionCarousel
          heading={intl.formatMessage({
            id: "app.poaOverview.inactivated.moreActions.headline",
            defaultMessage: "Mer om din pension",
          })}
          cards={cards}
        />
      </Stack>
    </AppWebviewLayout>
  );
}
